import { Component, OnInit } from '@angular/core';

async function deconnecter_fn() {
  var audio = new Audio('../assets/aud/exit.ogg');
  audio.play();
        localStorage.removeItem("connecteid");
        localStorage.removeItem("connectmdp");
        localStorage.removeItem("connectnom");
        window.location.href = '/connecter' ;

} ;

function hoversoundfn() {
  var audio = new Audio('../assets/aud/cursor.ogg');
audio.play();
}

function clicksoundfn() {
  var audio = new Audio('../assets/aud/select.ogg');
audio.play();
}

function aproposdefn() {
  alert("Bonjour !! \n\n Ceci est un mini-projet ISTIC pour le niveau LGLSI-2 en 2021 \n Réalisé par: Mohamed Dhia Jebali - Mariem Benjaballah - Aymen Tayari \n\n C'est une application web faite par angular pour la gestion des employés \n Vous pouvez ajouter, modifier, supprimer, chercher et consulter chaque employé dans la base de données de l'application");
}
  

async function backend_tester_fn() {
  var eid = localStorage.getItem("connecteid");
  var motdepasse = localStorage.getItem("connectmdp");
  const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_connecter_bd?eid=${eid}&motdepasse=${motdepasse}`) ;   
  if (rep.ok){
    rep.json().then((data)=>{ 
      if (data.length != 0) {
        if (data[0].admin == 1) {
          (document.getElementById("connectnomm") as HTMLFormElement).insertAdjacentHTML("afterbegin",data[0].nom+" ") ;
        }
        if (data[0].admin == 0) {
          window.location.href = '/accueilemploye' ;
        }
      }
      else {
        localStorage.removeItem("connecteid");
        localStorage.removeItem("connectmdp");
        localStorage.removeItem("connectnom");
        window.location.href = '/connecter' ;
      }
    }) 
  } else {
    localStorage.removeItem("connecteid");
    localStorage.removeItem("connectmdp");
    localStorage.removeItem("connectnom");
    window.location.href = '/connecter' ;
  }
} ;




async function backend_ajouter_chercher_tache_fn() {

  var d1 = document.getElementById('ac') ;
  var t = (d1 as HTMLFormElement).innerHTML ;
  var c = 0 ;
  do {
    c++ ;
    t = t.replace('id="t',"|") ;
  } while (t.includes('id="t') == true) ;

  

  (document.getElementById("dt1") as HTMLFormElement).innerHTML = 	`<h2> <select style="width: 286px; font-size:18px;" name="dt1" id="dt1"> <option value="0">Directeur de cette Tâche (EID)</option> </select> </h2>`
  
  const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_ajouter_chercher_tache_bd`) ;   

  if (rep.ok){
    rep.json().then((data)=>{ 

      for(var j=0; j<data.length;j++) {
        
        (document.getElementById("dt1") as HTMLFormElement).insertAdjacentHTML("beforeend",`<option value="${data[j].eid}">${data[j].eid}</option>`) ; 
      }

    })
}


  
  for (var x=1 ; x < c ; x++) {
    

    (document.getElementById("dt"+x) as HTMLFormElement).innerHTML = 	`<h2> <select style="width: 286px; font-size:18px;" name="dt`+x+`" id="dt`+x+`"> <option value="0">Directeur de cette Tâche (EID)</option> </select> </h2>`
  
    const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_ajouter_chercher_tache_bd`) ;   
  
    if (rep.ok){
      rep.json().then((data)=>{ 

        for(var j=0; j<data.length;j++) {
          
          (document.getElementById("dt"+x) as HTMLFormElement).insertAdjacentHTML("beforeend",`<option value="${data[j].eid}">${data[j].eid}</option>`) ; 
        }

      })
  }

}

  }

async function backend_modifier_chercher_fn() {

  var eid = (document.getElementById("eid") as HTMLFormElement).value ;
  const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_modifier_chercher_bd?eid=${eid}`) ;   
  

  if (rep.ok){

    rep.json().then((data)=>{ 

      (document.getElementById('eid') as HTMLFormElement).name =  (document.getElementById('eid') as HTMLFormElement).value ;

      (document.getElementById('cin') as HTMLFormElement).value =  data[0].cin ;
      (document.getElementById('cin') as HTMLFormElement).disabled =  false ;
      (document.getElementById('cin') as HTMLFormElement).name =  data[0].cin ;


      (document.getElementById('motdepasse') as HTMLFormElement).value =  data[0].mdp ;
      (document.getElementById('motdepasse') as HTMLFormElement).disabled =  false ;

      if (data[0].admin == 1) {  (document.getElementById('admincb') as HTMLFormElement).checked = true ;}  
      (document.getElementById('admincb') as HTMLFormElement).disabled =  false ;

      (document.getElementById('prenom') as HTMLFormElement).value =  data[0].prenom ;
      (document.getElementById('prenom') as HTMLFormElement).disabled =  false ;

      (document.getElementById('nom') as HTMLFormElement).value =  data[0].nom ;
      (document.getElementById('nom') as HTMLFormElement).disabled =  false ;

      (document.getElementById('dn') as HTMLFormElement).value =  data[0].datenaissance ;
      (document.getElementById('dn') as HTMLFormElement).disabled =  false ;

      (document.getElementById('ville') as HTMLFormElement).value =  data[0].ville ;
      (document.getElementById('ville') as HTMLFormElement).disabled =  false ;

      (document.getElementById('email') as HTMLFormElement).value =  data[0].email ;
      (document.getElementById('email') as HTMLFormElement).disabled =  false ;

      (document.getElementById('tel') as HTMLFormElement).value =  data[0].numtel ;
      (document.getElementById('tel') as HTMLFormElement).disabled =  false ;

      (document.getElementById('salaire') as HTMLFormElement).value =  data[0].salaire ;
      (document.getElementById('salaire') as HTMLFormElement).disabled =  false ;

      (document.getElementById('image') as HTMLFormElement).disabled =  false ;

      (document.getElementById('modifiersub') as HTMLFormElement).disabled =  false ;

    })


    const rep2 = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_modifier_chercher_tache_bd?eid=${eid}`) ;   
  
    if (rep2.ok){
      rep2.json().then((data)=>{ 
  

          if (data.length == 0) {

            var audio = new Audio('../assets/aud/miss.ogg');
            audio.play();

            alert("Aucun cin n'a été trouvé dans la base de données ")



          } else {
            var audio = new Audio('../assets/aud/loaded.ogg');
            audio.play();
        }

        (document.getElementById("ac") as HTMLFormElement).innerHTML = `    <div id="ac">   </div>`
        
        for(var i=0 ; i<data.length;i++) { 

          var j = i + 1 ;
 
          (document.getElementById('ajoutertac') as HTMLFormElement).disabled = false ;
          (document.getElementById('ac') as HTMLFormElement).insertAdjacentHTML("beforeend",`<h2>
          <input type="text" size=30 style="font-size:18px;" name="t`+ j +`" id="t`+ j +`" value=" ${data[i].tachenom}">
          </h2>
          <h2>
          <select style="width: 286px; font-size:18px;" name="dt`+ j +`" id="dt`+ j +`"> <option value="0">Directeur de cette Tâche (EID)</option> </select>
          </h2> <br>
          ` ) ;
          backend_ajouter_chercher_tache_fn()
        }
      }) 
    }
  

    


}



} ;







function ajoutertachefn() {
  var d1 = document.getElementById('ac') ;
  var t = (d1 as HTMLFormElement).innerHTML ;
  var c = 1 ;
  do {
    c++ ;
    t = t.replace('id="t',"|") ;
  } while (t.includes('id="t') == true) ;

  var code = '<h2><input type="text" size=30 style="font-size:18px;" name="t' + c + '" id="t' + c + '" value="Nom de Tâche" pattern="[A-z0-9À-ž\s]{3,30}"></h2> <h2> <select style="width: 286px; font-size:18px;" name="dt' + c + '" id="dt' + c + '"> <option value="0">Directeur de cette Tâche (EID)</option> </select></h2> <br>' ;
  (d1 as HTMLFormElement).insertAdjacentHTML('beforeend',code) ;

  backend_ajouter_chercher_tache_fn() ;
 
}

@Component({
  selector: 'app-modifier',
  templateUrl: './modifier.component.html',
  styleUrls: ['./modifier.component.css']
})
export class ModifierComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    backend_tester_fn() ;
  }

  
  aproposderun() {
    aproposdefn();
  }

    
  ajoutertache() {
    ajoutertachefn();
  }

  backend_modifier_chercher() {
    backend_modifier_chercher_fn();
  }

  url!: string;

  
  onSelectFile(event:any){
    console.log("here");
    if (event.target.files && event.target.files[0]){
      var reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = async (event) =>{
        this.url = event.target?.result as string;
      }
    }
  }

  async backend_modifier() {


    let urlp = "http://127.0.0.1:8000/gestionemployes/backend_modifier_comptep_bd" ;
    var eid = (document.getElementById('eid') as HTMLFormElement).getAttribute("name") ; 
    
    let postp = `{"eid":"${eid}"}` 
    const repp = await fetch(urlp, {
      method:"POST" , 
      body : postp
    })
  
    if (repp.ok){
      
    let url = "http://127.0.0.1:8000/gestionemployes/backend_modifier_personne_bd" ;
    var cinx = (document.getElementById('cin') as HTMLFormElement).getAttribute("name") ; 
    var cin = (document.getElementById("cin") as HTMLFormElement).value ;
    var prenom = (document.getElementById("prenom") as HTMLFormElement).value ;
    var nom = (document.getElementById("nom") as HTMLFormElement).value ;
    var datenaissance = (document.getElementById("dn") as HTMLFormElement).value ;
    var ville = (document.getElementById("ville") as HTMLFormElement).value ;
    var email = (document.getElementById("email") as HTMLFormElement).value ;
    var numtel = (document.getElementById("tel") as HTMLFormElement).value ;
    let post = `{"cin":"${cin}" , "prenom":"${prenom}" , "nom":"${nom}" , "datenaissance":"${datenaissance}" , "ville":"${ville}" , "email":"${email}" , "numtel":"${numtel}", "photo":"${this.url}", "cinx":"${cinx}" }` 
    const rep = await fetch(url, {
      method:"POST" , 
      body : post
    })
  
    if (rep.ok){
  
      let url2 = "http://127.0.0.1:8000/gestionemployes/backend_modifier_compte_bd" ;
      var eid = (document.getElementById('eid') as HTMLFormElement).getAttribute("name") ; 
      var salaire = (document.getElementById("salaire") as HTMLFormElement).value ;
      var motdepasse = (document.getElementById("motdepasse") as HTMLFormElement).value ;
      var admin = 0 ;
      var admincb = (document.getElementById("admincb") as HTMLFormElement).checked ;
      if (admincb == true) {admin = 1 ;}
      var cin = (document.getElementById("cin") as HTMLFormElement).value ;
      let post2 = `{"eid":"${eid}","salaire":"${salaire}" ,"motdepasse":"${motdepasse}","admin":"${admin}","cin":"${cin}"}` 
      const rep2 = await fetch(url2, {
        method:"POST" , 
        body : post2
      })
    
      if (rep2.ok){
  
        let urli = "http://127.0.0.1:8000/gestionemployes/backend_init_modifier_tache_bd" ;
        var eid = (document.getElementById('eid') as HTMLFormElement).getAttribute("name") ; 
        let posti = `{"eid":"${eid}"}` 
        const repi = await fetch(urli, {
          method:"POST" , 
          body : posti
        })
  
        if (repi.ok){}
  
  
  
  
  
        let url3 = "http://127.0.0.1:8000/gestionemployes/backend_ajouter_tache_bd" ;
        var d1 = document.getElementById('ac') ;
        var t = (d1 as HTMLFormElement).innerHTML ;
        var c = 0 ;
        do {
          c++ ;
          t = t.replace('id="t',"|") ;
        } while (t.includes('id="t') == true) ;
      
        for (var i=1 ; i <= c ; i++) {
          var tnom = (document.getElementById("t"+i) as HTMLFormElement).value ;
  
          if (tnom != "") {
          var deid = (document.getElementById("dt"+i) as HTMLFormElement).value ;
          var eid = (document.getElementById('eid') as HTMLFormElement).getAttribute("name") ; 
          let post3 = `{"tnom":"${tnom}" , "deid":"${deid}" , "eid":"${eid}"}` 
          var rep3 = await fetch(url3, {
            method:"POST" , 
            body : post3
          })
          if (rep3.ok){
  
           
  
          } }
  
          
  
  
    }
  
    var audio = new Audio('../assets/aud/success.ogg');
    audio.play(); alert("La modification a réussi !") ;
  
    }else {
  
      var audio = new Audio('../assets/aud/erreur.ogg');
      audio.play(); alert("La modification a échoué.\n\nAssurez-vous que les valeurs insérées sont valides") ;
  
  
    }
  
  }else {
  
    var audio = new Audio('../assets/aud/erreur.ogg');
    audio.play(); alert("La modification a échoué.\n\nAssurez-vous que les valeurs insérées sont valides") ;
  
  
  }
  
  
    }
  
  
  
  
  
  };


  hoversound() {
    hoversoundfn();
  }

  clicksound() {
    clicksoundfn();
  }

  deconnecter() {
    deconnecter_fn() 
  }



}
